var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("validation-observer", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function({ handleSubmit }) {
          return [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12 text-bold bold mb-3" }, [
                _c("i", { staticClass: "fa fa-redo-alt color-orange" }),
                _vm._v(" " + _vm._s(_vm.title) + " ")
              ]),
              _c(
                "div",
                { staticClass: "col-md-4" },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-date-picker", {
                                attrs: {
                                  "class-container": "w-100",
                                  "custom-error-msg":
                                    "Favor seleccione la fecha de recepción.",
                                  error: errors[0],
                                  label: "Fecha:",
                                  "max-date": new Date(),
                                  "min-date": _vm.beforeBankRequestDate,
                                  placeholder: "DD/MM/YYYY"
                                },
                                model: {
                                  value: _vm.model.receptionDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "receptionDate", $$v)
                                  },
                                  expression: "model.receptionDate"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-md-12 mt-2" },
                [
                  _c("custom-text-area", {
                    attrs: {
                      label: "Comentario:",
                      maxlength: 500,
                      rows: 4,
                      "show-char-count": ""
                    },
                    model: {
                      value: _vm.model.comment,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "comment", $$v)
                      },
                      expression: "model.comment"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-md-12 text-right mt-3 pt-1" },
                [
                  _c("action-button", {
                    attrs: {
                      i: "fas fa-times-circle",
                      text: "Cancelar",
                      variant: "outline-danger mr-3"
                    },
                    on: {
                      click: function($event) {
                        return _vm.$emit("on-cancel")
                      }
                    }
                  }),
                  _c("action-button", {
                    attrs: {
                      i: "fas fa-save",
                      text: "Guardar",
                      variant: "success"
                    },
                    on: {
                      click: function($event) {
                        return handleSubmit(_vm.submit)
                      }
                    }
                  })
                ],
                1
              )
            ])
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }